import {FC} from 'react';

import {Box, Paper, Stack} from '@mui/material';
import AssignTo from './AssignTo/index';
import {FiltersAndTableContainer} from './FiltersAndTableContainer';

const AssignServiceRequests: FC = () => {
  return (
    <Box sx={{width: '100%', height: '100%'}}>
      <Box sx={{p: 2, height: 'calc(100% - 32px)'}}>
        <Stack sx={{height: '100%'}} direction="row" spacing={2}>
          <Stack sx={{width: '80%'}} direction="column" spacing={2}>
            <FiltersAndTableContainer />
          </Stack>
          <Paper sx={{width: '20%', marginTop: '16px !important', height: 'calc(100% - 16px)'}}>
            <AssignTo />
          </Paper>
        </Stack>
      </Box>
    </Box>
  );
};

export default AssignServiceRequests;
